import Home from './Home.Performance'

export default {
  Home
}